// This program has been developed by students from the bachelor Computer Science
// at Utrecht University within the Software Project course. Copyright (c) Utrecht
// University (Department of Information and Computing Sciences)

import Theme from "../../Theme";

//import spritesheets
import s_ground from "@/assets/images/worlds/default/desert/Ground.png";
import s_path from "@/assets/images/worlds/default/desert/Path.png";
import s_icon from "@/assets/images/worlds/default/desert/Icon.png";
import s_deco from "@/assets/images/worlds/default/desert/Decoration.png";
import s_small from "@/assets/images/worlds/default/desert/Small.png";
import s_start from "@/assets/images/worlds/default/desert/Start.png";
import s_end from "@/assets/images/worlds/default/desert/End.png";
import s_character from "@/assets/images/worlds/default/desert/Character.png";

//Sprite mappings
import m_ground from "@/utils/world/default/desert/mappings/Ground.json";
import m_path from "@/utils/world/default/desert/mappings/Path.json";
import m_icon from "@/utils/world/default/desert/mappings/Icon.json";
import m_start from "@/utils/world/default/desert/mappings/Start.json";
import m_end from "@/utils/world/default/desert/mappings/End.json";
import m_character from "@/utils/world/default/desert/mappings/Character.json";

//import sounds
import move from "@/assets/sounds/default/farm/Tractor.ogg";
import rotate from "@/assets/sounds/default/farm/Rotate.ogg";
import finish from "@/assets/sounds/default/farm/Finish.ogg";
import crash from "@/assets/sounds/default/farm/Crash.ogg";
import background from "@/assets/sounds/default/desert/Background.ogg";
import insects from "@/assets/sounds/default/desert/Insects.ogg";
import lizard from "@/assets/sounds/default/desert/Lizard.ogg";
import mosquito from "@/assets/sounds/default/desert/Mosquito.ogg";
import wolf from "@/assets/sounds/default/desert/Wolf.ogg";
import snake from "@/assets/sounds/default/desert/Snake.ogg";

import { spriteMap } from "@/utils/Types";

export default class DesertTheme implements Theme {
  assets: { name: string; url: string }[];
  sounds: { name: string; url: string; ambient: boolean }[];
  mappings: Record<string, spriteMap>;
  smallDecoSize = { width: 3, height: 3 };
  largeDecoSize = { width: 3, height: 1 };

  constructor() {
    this.sounds = [
      { name: "MoveTo", url: move, ambient: false },
      { name: "Rotate", url: rotate, ambient: false },
      { name: "Finish", url: finish, ambient: false },
      { name: "Crash", url: crash, ambient: false },
      { name: "Background", url: background, ambient: false },
      { name: "Insects", url: insects, ambient: true },
      { name: "Lizard", url: lizard, ambient: true },
      { name: "Mosquito", url: mosquito, ambient: true },
      { name: "Wolf", url: wolf, ambient: true },
      { name: "Snake", url: snake, ambient: true },
    ];
    this.assets = [
      { name: "ground", url: s_ground },
      { name: "path", url: s_path },
      { name: "icon", url: s_icon },
      { name: "deco", url: s_deco },
      { name: "small", url: s_small },
      { name: "start", url: s_start },
      { name: "end", url: s_end },
      { name: "char", url: s_character },
    ];

    this.mappings = {};
    this.mappings.ground = m_ground;
    this.mappings.path = m_path;
    this.mappings.icon = m_icon;
    this.mappings.start = m_start;
    this.mappings.end = m_end;
    this.mappings.character = m_character;
  }
}
